<template>
  <div class="page">
    <div class="header">
      <div class="divs">
        <div class="fz18">自营挂账</div>
      </div>
    </div>
    <div v-if="empty.length !==0" class="notempty">
      <!-- 账单信息 -->
      <div class="Account">
        <h3 class="fz20 pb5 bgb7">账单信息</h3>
        <Row class="p15">
          <Col span="3">当前应还:</Col>
          <Col span="5">{{ data.receivableAmt }}</Col>
        </Row>
      </div>
      <!-- 结算 -->
      <div>
        <h3 class="fz20 pb5 bgb7">结算约定情况</h3>
        <Row class="p15">
          <Col span="3">回款方式:</Col>
          <Col span="6">{{ data.cashModeName }}</Col>
          <Col span="3">回款日期:</Col>
          <Col span="5">{{ data.cashDate }}</Col>
        </Row>
        <Row class="pb15">
          <Col span="3">约定对账日期:</Col>
          <Col span="10">{{ data.accountDate }}</Col>
        </Row>
      </div>
      <!-- 信用额度 -->
      <div>
        <h3 class="fz20 pb5 bgb7">信用额度</h3>
        <Row class="p15">
          <Col span="3">固定额度:</Col>
          <Col span="6">{{ data.creditLimit }}</Col>
          <Col span="3">临时额度:</Col>
          <Col span="5">{{ data.tempCreditLimit }}</Col>
        </Row>
        <Row>
          <Col span="3">临时额度有效日期：</Col>
          <Col span="10">{{ data.tempStart}} 至 {{data.tempEnd}}</Col>
        </Row>
      </div>
    </div>
    <div v-if="empty.length ===0" class="empty">
     <img 
        src="@/assets/images/ziying.png"  
        style="width: 200px; height: 210px" 
      />
      <!-- <h1>您暂无联自营账额度。</h1> -->
      <div class="flex">
        <div class="shoppingNull">
          <span class="iconfont icon-gantanhao-xianxingyuankuang"
          style="width: 17px;height: 17px;opacity: 1;margin-right:9px"></span>
          <span>抱歉！您还无自营挂账额度~</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { autotrophygz } from '@/api/myweb/finance/autotrophy'
import { syncCreditMsgzy } from '@/api/myweb/finance/autotrophy'
export default {
  data() {
    return {
      data: {
        /* yh: '25.36',
        hkfs: '月结',
        hqrq: '每月25日',
        yddzrq: '每月15日',
        gded: '50000.00',
        lsed: '20000.00',
        lsedysrq: '2022年01月08日 至 2022年02月07日' */
      },
      empty:[]
    }
  },
  created() {
    this.syncCreditMsglist()
  },
  methods: {
    // 自营挂账数据
    /* async autotrophylist() {
      const res = await autotrophygz({})
      console.log(res)
      if (res.status) {
        this.data = res.data
      }
    }, */
    // 自营挂账数据
    async syncCreditMsglist() {
      const res = await syncCreditMsgzy({})
      if (res.status) {
        this.empty=res.data.list
        res.data.list.forEach((item,index) => {
          // console.log(res.data.list[index].type,'type');
          if(res.data.list[index].type ==1){
            this.data=res.data.list[index]
          }
        });
      }
      // console.log(222);
      // console.log(this.empty,'y');
    }
  }
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
